(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function clamp(value) {
    if (value < 0) return 0;
    if (value > 100) return 100;
    return value;
  }

  if (!customElements.get('before-after-compare')) {
    customElements.define(
      'before-after-compare',
      class BeforeAfterCompare extends HTMLElement {
        constructor() {
          super();
          this.onPointerDown = this.onPointerDown.bind(this);
          this.onPointerMove = this.onPointerMove.bind(this);
          this.onPointerUp = this.onPointerUp.bind(this);
          this.onHoverMove = this.onHoverMove.bind(this);
          this.onKeyDown = this.onKeyDown.bind(this);
          this.onIntersect = this.onIntersect.bind(this);
          this.dragging = false;
          this.touched = false;
        }

        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;

          this.frame = this.querySelector('.bac-frame');
          this.knob = this.querySelector('[data-bac-knob]');
          if (!this.frame || !this.knob) return;

          this.vertical = this.dataset.orientation === 'vertical';
          this.mode = this.dataset.mode || 'both';
          this.start = parseFloat(this.dataset.start);
          if (isNaN(this.start)) this.start = 50;
          this.position = this.start;

          this.setPosition(this.start, true);

          this.frame.addEventListener('pointerdown', this.onPointerDown);
          this.knob.addEventListener('keydown', this.onKeyDown);

          if (this.usesHover()) {
            this.frame.addEventListener('pointermove', this.onHoverMove);
            this.frame.addEventListener('pointerleave', this.onPointerUp);
          }

          if (this.dataset.reveal === 'true' && !reduceMotion.matches) {
            this.setupReveal();
          }
        }

        disconnectedCallback() {
          window.removeEventListener('pointermove', this.onPointerMove);
          window.removeEventListener('pointerup', this.onPointerUp);
          window.removeEventListener('pointercancel', this.onPointerUp);
          if (this.observer) this.observer.disconnect();
          if (this.raf) window.cancelAnimationFrame(this.raf);
        }

        usesHover() {
          if (this.mode === 'hover') return true;
          if (this.mode !== 'both') return false;
          return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        }

        /* Position ----------------------------------------------------- */

        setPosition(value, silent) {
          var next = clamp(value);
          this.position = next;
          this.style.setProperty('--bac-pos', next.toFixed(2) + '%');
          if (this.knob) {
            this.knob.setAttribute('aria-valuenow', Math.round(next));
          }
          if (!silent) this.markTouched();
        }

        markTouched() {
          if (this.touched) return;
          this.touched = true;
          this.classList.add('is-touched');
        }

        positionFromEvent(event) {
          var rect = this.frame.getBoundingClientRect();
          if (!rect.width || !rect.height) return this.position;

          if (this.vertical) {
            return ((event.clientY - rect.top) / rect.height) * 100;
          }
          return ((event.clientX - rect.left) / rect.width) * 100;
        }

        /* Drag --------------------------------------------------------- */

        onPointerDown(event) {
          if (event.button !== undefined && event.button !== 0) return;
          if (this.mode === 'hover') return;

          this.stopReveal();
          this.dragging = true;
          this.frame.classList.add('is-dragging');
          this.setPosition(this.positionFromEvent(event));

          window.addEventListener('pointermove', this.onPointerMove);
          window.addEventListener('pointerup', this.onPointerUp);
          window.addEventListener('pointercancel', this.onPointerUp);

          if (event.pointerType !== 'mouse') event.preventDefault();
        }

        onPointerMove(event) {
          if (!this.dragging) return;
          event.preventDefault();
          this.setPosition(this.positionFromEvent(event));
        }

        onPointerUp() {
          this.dragging = false;
          if (this.frame) this.frame.classList.remove('is-dragging');
          window.removeEventListener('pointermove', this.onPointerMove);
          window.removeEventListener('pointerup', this.onPointerUp);
          window.removeEventListener('pointercancel', this.onPointerUp);
        }

        onHoverMove(event) {
          if (this.dragging) return;
          if (event.pointerType && event.pointerType !== 'mouse') return;
          this.stopReveal();
          this.setPosition(this.positionFromEvent(event));
        }

        /* Keyboard ----------------------------------------------------- */

        onKeyDown(event) {
          var step = event.shiftKey ? 10 : 2;
          var handled = true;

          switch (event.key) {
            case 'ArrowLeft':
            case 'ArrowDown':
              this.setPosition(this.position - step);
              break;
            case 'ArrowRight':
            case 'ArrowUp':
              this.setPosition(this.position + step);
              break;
            case 'Home':
              this.setPosition(0);
              break;
            case 'End':
              this.setPosition(100);
              break;
            case 'PageDown':
              this.setPosition(this.position - 10);
              break;
            case 'PageUp':
              this.setPosition(this.position + 10);
              break;
            default:
              handled = false;
          }

          if (handled) {
            this.stopReveal();
            event.preventDefault();
          }
        }

        /* Reveal sweep -------------------------------------------------- */

        setupReveal() {
          if (!('IntersectionObserver' in window)) return;

          this.observer = new IntersectionObserver(this.onIntersect, {
            threshold: 0.35
          });
          this.observer.observe(this);
        }

        onIntersect(entries) {
          var entry = entries[0];
          if (!entry || !entry.isIntersecting) return;
          if (this.observer) this.observer.disconnect();
          if (this.touched) return;
          this.playReveal();
        }

        playReveal() {
          var self = this;
          var from = this.start;
          var keyframes = [from, Math.max(from - 26, 6), Math.min(from + 26, 94), from];
          var legDuration = 620;
          var startTime = null;
          var leg = 0;

          function ease(t) {
            return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
          }

          function step(now) {
            if (self.revealStopped) return;
            if (startTime === null) startTime = now;

            var elapsed = now - startTime;
            var t = elapsed / legDuration;

            if (t >= 1) {
              t = 0;
              leg += 1;
              startTime = now;
              if (leg >= keyframes.length - 1) {
                self.setPosition(from, true);
                return;
              }
            }

            var a = keyframes[leg];
            var b = keyframes[leg + 1];
            self.setPosition(a + (b - a) * ease(t), true);
            self.raf = window.requestAnimationFrame(step);
          }

          this.raf = window.requestAnimationFrame(step);
        }

        stopReveal() {
          this.revealStopped = true;
          if (this.raf) window.cancelAnimationFrame(this.raf);
        }
      }
    );
  }

  /* Scroll reveal for the section ------------------------------------- */

  function revealSection(root) {
    var targets = Array.prototype.slice.call(
      root.querySelectorAll('.bac-animate')
    );
    if (!targets.length) return;

    if (!('IntersectionObserver' in window) || reduceMotion.matches) {
      targets.forEach(function (el) {
        el.classList.add('bac-animate--in');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('bac-animate--in');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.1 }
    );

    targets.forEach(function (el, index) {
      el.style.transitionDelay = Math.min(index * 90, 450) + 'ms';
      observer.observe(el);
    });
  }

  function initSections(root) {
    Array.prototype.forEach.call(
      root.querySelectorAll('.bac-section'),
      function (section) {
        if (section.dataset.bacReady === 'true') return;
        section.dataset.bacReady = 'true';
        revealSection(section);
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSections(document);
    });
  } else {
    initSections(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSections(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    Array.prototype.forEach.call(
      event.target.querySelectorAll('.bac-animate'),
      function (el) {
        el.classList.add('bac-animate--in');
      }
    );
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
